import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import LiveClock from "@/components/LiveClock";
import ChangePasswordDialog from "@/components/ChangePasswordDialog";

const roleLabel = {
  admin: "Admin Console",
  cafeteria: "Cafeteria Station",
  kitchen: "Base Kitchen",
  store: "Store / Inventory",
  planner: "Menu Planner",
};

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/login", { replace: true, state: null });
    logout();
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-background/85 border-b border-orange-100 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3" data-testid="nav-brand-logo">
          <img src="/baron-logo.jpg" alt="Baron Kitchen" className="h-11 w-auto rounded-lg shadow-sm" />
          <div className="flex items-center">
            <p className="text-[11px] uppercase font-mono tracking-widest text-amber-700 dark:text-amber-400">
              {roleLabel[user?.role] || "Operations"}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 sm:gap-5">
          <LiveClock />
          <div className="hidden sm:flex flex-col items-end leading-tight" data-testid="nav-role-badge">
            <span className="text-sm font-semibold">{user?.name}</span>
            <span className="text-xs text-muted-foreground">
              {user?.location || (user?.role === "admin" ? "Administrator" : "")}
            </span>
          </div>
          {user?.role === "admin" && <ChangePasswordDialog />}
          <Button
            variant="outline"
            size="sm"
            onClick={handleLogout}
            data-testid="nav-logout-button"
            className="gap-2"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Logout</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
